import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import UserTab from "../UserTab";
import Table from "../Table";
import CurrentUser from "../CurrentUser";
import Parametros from "../Parametros";
import ReactSelect from "react-select";
import EliminarElemento from "../EliminarElemento";
import EmptyTableRow from "../EmptyTableRow";
const INITIAL_FORM_STATE = { name: "", client: null };
const INITIAL_PAGINATION_STATE = {
  limit: 5,
  skip: 1,
};

function Carteras(props) {
  const [paginacionState, setPaginacionState] = useState(
    INITIAL_PAGINATION_STATE
  );
  const [paginas, setPaginas] = useState(0);
  const [usuario] = useState(CurrentUser.user);
  const [update, setUpdate] = useState(true);
  const [data, setData] = useState([]);
  const [formState, setFormState] = useState(INITIAL_FORM_STATE);
  const [editable, setEditable] = useState(null);
  const [busqueda, setBusqueda] = useState(INITIAL_FORM_STATE);
  const [clients, setClients] = useState([]);
  const [updatePagination, setUpdatePagination] = useState(true);

  useEffect(() => {
    let url = `${Parametros.urlApi}porfolios/paginated?skip=${paginacionState.skip}&limit=${paginacionState.limit}`;
    const optsKeys = ["client"];
    for (const key in busqueda) {
      if (optsKeys.includes(key) && busqueda[key]?.value) {
        url += `&${key}=${busqueda[key].value}`;
      } else if (busqueda[key] && !optsKeys.includes(key)) {
        url += `&${key}=${busqueda[key]}`;
      }
    }
    fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data.data);
        setPaginas(data.n_pages);
      });
  }, [usuario.key, paginacionState, update]);

  useEffect(() => {
    fetch(`${Parametros.urlApi}clients`, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setClients(data);
      });
  }, [usuario.key]);

  const handleChange = (e) => {
    setFormState({
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeBusqueda = (e) => {
    setBusqueda({
      ...busqueda,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeUpdate = (e) => {
    setEditable({
      ...editable,
      [e.target.name]: e.target.value,
    });
  };

  const handleCrear = (e) => {
    e.preventDefault();
    if (usuario.permisos.indexOf("Crear") > -1) {
      if (window.confirm("¿Esta seguro que deseas agregar este elemento?")) {
        const formToSubmit = {
          name: formState.name,
          client: formState?.client?.value,
        };
        fetch(Parametros.urlApi + "portfolio", {
          method: "POST",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
          body: JSON.stringify(formToSubmit),
        })
          .then((res) => res.json())
          .then((data) => {
            alert(data.message || data.detail);
            setUpdate(!update);
            setFormState(INITIAL_FORM_STATE);
          });
      }
    } else {
      console.log(usuario.crear);
    }
  };

  const handleConfirmEditar = () => {
    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro que deseas editar este elemento?")) {
        const formToSubmit = {
          name: editable.name,
          client: editable.client.value,
        };
        fetch(Parametros.urlApi + "portfolio/" + editable.portfolio_id, {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
          body: JSON.stringify(formToSubmit),
        })
          .then((res) => res.json())
          .then((data) => {
            alert(data.message || data.detail);
            setUpdate(!update);
            setEditable(null);
          });
      }
    } else {
      console.log(usuario.editar);
    }
  };

  const handleCancelEditar = () => {
    setEditable(null);
  };

  const handleEditar = (item) => {
    const client = clients?.find((c) => c.client_id === item.client);
    setEditable({
      ...item,
      client: {
        value: client?.client_id,
        label: client?.name,
      },
    });
  };

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <div className="container">
        <UserTab nombre={"Carteras"}></UserTab>

        <form id="formCrear" className="col-md-12" onSubmit={handleCrear}>
          <div className="col-md-4">
            <h5>Nombre</h5>
            <input
              onChange={handleChange}
              value={formState.name}
              name="name"
              required
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Cliente</h5>
            <ReactSelect
              onChange={(opt) => setFormState({ ...formState, client: opt })}
              value={formState.client}
              options={clients?.map((client) => ({
                value: client.client_id,
                label: client.name,
              }))}
            />
          </div>

          <div className="col-md-4">
            <br />
            <button
              type="submit"
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Agregar nuevo
            </button>
          </div>
        </form>

        <form id="formBusqueda" className="col-md-12">
          <hr style={{ height: "8px", color: "black" }}></hr>

          <div className="col-md-4">
            <h5>Nombre</h5>
            <input
              onChange={handleChangeBusqueda}
              value={busqueda.name}
              name="name"
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Cliente</h5>
            <ReactSelect
              onChange={(opt) => setBusqueda({ ...busqueda, client: opt })}
              value={busqueda.client}
              options={[
                { value: null, label: "Todos" },
                ...clients?.map((client) => ({
                  value: client.client_id,
                  label: client.name,
                })),
              ]}
            />
          </div>

          <div className="col-md-4">
            <br />
            <button
              onClick={() => {
                setUpdate(!update);
                setUpdatePagination((prev) => !prev);
                setPaginacionState(INITIAL_PAGINATION_STATE);
              }}
              type="button"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Buscar
            </button>
          </div>
        </form>

        <div
          className="col-md-12 table-responsive"
          style={{ width: "100%" }}
        >
          <Table
            type={1}
            key={updatePagination}
            paginas={paginas}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            paginationBelow={true}
            elementos={["Nombre", "Cliente", "Activo"]}
          ></Table>
          <table className="table table-bordered" id="myTable">
            <Table type={2} elementos={["Nombre", "Cliente", "Activo"]}></Table>

            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {(!data || data.length === 0) && (
                  <EmptyTableRow colSpan={20} />
                )}
                {data?.map((item, index) => {
                  return (
                    <tr key={item.portfolio_id}>
                      {editable?.portfolio_id === item.portfolio_id ? (
                        <>
                          <td>{item.portfolio_id}</td>
                          <td>
                            <input
                              value={editable.name}
                              name="name"
                              onChange={handleChangeUpdate}
                              className="form-control"
                            ></input>
                          </td>

                          <td>
                            <ReactSelect
                              onChange={(opt) =>
                                setEditable({ ...editable, client: opt })
                              }
                              value={editable.client}
                              options={clients?.map((client) => ({
                                value: client.client_id,
                                label: client.name,
                              }))}
                            />
                          </td>
                          <td>{item.is_active ? "Activo" : "Inactivo"}</td>

                          <td>
                            <abbr title="Confirmar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  handleConfirmEditar(item);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              ></span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  handleCancelEditar(item);
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.portfolio_id}</td>
                          <td>{item.name}</td>
                          <td>
                            {
                              clients?.find((c) => c.client_id === item.client)
                                ?.name
                            }
                          </td>
                          <td>{item.is_active ? "Activo" : "Inactivo"}</td>

                          <td>
                            <abbr title="Editar Elemento">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  handleEditar(item);
                                }}
                                className="glyphicon glyphicon-pencil"
                              ></span>
                            </abbr>
                            <EliminarElemento
                              endpoint={`portfolio/active/${item.portfolio_id}?active=false`}
                              method="PUT"
                              onSuccess={() => {
                                setUpdate(!update);
                              }}
                            />
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={paginas}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
    </div>
  );
}

export default withRouter(Carteras);
